import InstanceSize, { InstanceSizeClassProps } from './InstanceSize';

export type InstanceSizesClassProps = {
    aws: InstanceSizeClassProps[];
    safespring: InstanceSizeClassProps[];
    lintasarta: InstanceSizeClassProps[];
    elastx: InstanceSizeClassProps[];
    syseleven: InstanceSizeClassProps[];
};

export interface InstanceSizesInterface {
    aws: InstanceSize[];
    safespring: InstanceSize[];
    lintasarta: InstanceSize[];
    elastx: InstanceSize[];
    syseleven: InstanceSize[];
}

export default class InstanceSizes implements InstanceSizesInterface {
    readonly aws: InstanceSize[];
    readonly safespring: InstanceSize[];
    readonly lintasarta: InstanceSize[];
    readonly elastx: InstanceSize[];
    readonly syseleven: InstanceSize[];

    constructor(props: InstanceSizesClassProps) {
        this.aws = (props.aws || []).map(
            (instanceSize: InstanceSizeClassProps) =>
                new InstanceSize(instanceSize)
        );

        this.safespring = (props.safespring || []).map(
            (instanceSize: InstanceSizeClassProps) =>
                new InstanceSize(instanceSize)
        );

        this.lintasarta = (props.lintasarta || []).map(
            (instanceSize: InstanceSizeClassProps) =>
                new InstanceSize(instanceSize)
        );

        this.elastx = (props.elastx || []).map(
            (instanceSize: InstanceSizeClassProps) =>
                new InstanceSize(instanceSize)
        );

        this.syseleven = (props.syseleven || []).map(
            (instanceSize: InstanceSizeClassProps) =>
                new InstanceSize(instanceSize)
        );
    }
}
